module.exports = __webpack_public_path__ + "img/no-camera.89beef62.svg";